import React, {Component} from "react";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import {
  RESERVE_RESULT_LINK,
  LOGIN_LINK,
  ROOM_LIST_URL,
  ROOM_RESERVE_URL,
  CHECK_TOKEN_URL,
  LOGIN_SUCCESS, LOGIN_ERROR
} from "../actions/types";
import {DatePicker, TimePicker, MuiPickersUtilsProvider} from "material-ui-pickers";
import EditIcon from "@material-ui/icons/Edit.js";
import MomentUtils from "@date-io/moment";
import IconCount from "../images/icon_count_white.svg";
import IconVideo from "../images/icon_video_white.svg";
import IconLaptop from "../images/icon_laptop_white.svg";
import IconBlackboard from "../images/icon_blackboard_white.svg";
import Iconspeaker from "../images/icon_speaker_white.svg";
import BackToUpperLevel from "./BackToUpperLevel.js";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import "moment/locale/zh-cn";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";

import creatHistory from 'history/createHashHistory'  //返回上一页这段代码
const history = creatHistory();//返回上一页这段代码
moment.locale("zh-cn");

class RoomDetailForm extends Component {
  state = {
    room: this.props.location.state ? this.props.location.state.room : {},
    startDate: null,
    startTime: null,
    endTime: null,
    reserveName: "",
    reserveDesc: "",
    reserveOther: "",
    filter: false,
    open: false,
    errMessage: "",

    Y_pass: "",
    Y_passShow: "",
    N_pass: "",
    N_passShow: "",
    NC_pass: "",
    NC_passShow: "",
    loginName: ""
  };

  componentDidMount() {
    document.body.style.position = "fixed";
    let _this = this;
    axios({
      method: "get",
      url: `${CHECK_TOKEN_URL}`,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
      }
    }).then(function (res) {
      console.log(res.data.userInfo.loginName, '333')
      _this.setState({loginName: res.data.userInfo.loginName});
    }).catch(err => {
    })
  }

  componentWillUnmount() {
    document.body.style.position = "";
    this.setState = (state, callback) => {
      return;
    };
  }

  componentWillUpdate(nextProps) {
    if (nextProps.location.state) {
      let {timeStamp} = nextProps.location.state;
      let nowTimeStamp = new Date().valueOf();
      if (nextProps.location.state.timeStamp && timeStamp + 3600000 > nowTimeStamp) {
        if (!this.state.startDate) {
          this.setState({startDate: moment(nextProps.location.state.timeStamp)});
        }
      }
    }
  }

  submit() {
    const {loginName, Y_pass, N_pass, NC_pass} = this.state;
    let _this = this;
    console.log(this.state.info, '333');
    // if (NC_pass.length < 8) {
    //   alert("密码为8位(英文字符、数字、特殊字符)");
    //   return;
    // }
    if (N_pass !== NC_pass) {//aa1111##
      this.setState({N_pass: ""});
      this.setState({NC_pass: ""});
      alert("两次输入的密码不同，请重新输入。");
      return
    }
    axios({
      method: "post",
      url: `/lab/rest/reservations/modifyPwd/${loginName}`,
      data: {
        loginName: loginName,
        oldPassword: Y_pass,
        newPassword: N_pass
      },
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
      }
    }).then(res => {
      console.log(res.data.message);
      // if (res.code == 400) {
        alert(res.data.message);
      // }
    }).catch(err => {
      this.props.history.push(LOGIN_LINK)
    })
  }

  render() {
    const {startDate, startTime, endTime, convener, reserveName, reserveDesc} = this.state;
    let isDisabled =
      startDate === null || startTime === null || endTime === null || convener === "" || (reserveName === "" || reserveDesc === "");
    return (
      <React.Fragment>
        <BackToUpperLevel title="修改密码" history={this.props.history}/>
        <div className="room-reserve">
          <section className="room-scroll">
            <form className="room-form" noValidate autoComplete="off">
              <br></br>
              <br></br>
              <TextField color="secondary"
                         id="password"
                         type={this.state.Y_passShow ? "text" : "password"}
                         label="原密码"
                         fullWidth
                         value={this.state.Y_pass}
                         onChange={(event) => {
                           this.setState({Y_pass: event.target.value})
                         }}
                         InputProps={{
                           endAdornment: (
                             <InputAdornment position="end">
                               <IconButton aria-label="Toggle password visibility"
                                           onClick={() => {
                                             this.setState(state => ({Y_passShow: !this.state.Y_passShow}));
                                           }}>
                                 {this.state.Y_passShow ? <VisibilityOff/> : <Visibility/>}
                               </IconButton>
                             </InputAdornment>
                           )
                         }}
                         variant="outlined"
                         style={{marginBottom: 16}}/>
              <TextField color="secondary"
                         id="password"
                         type={this.state.N_passShow ? "text" : "password"}
                         label="新密码"
                         fullWidth
                         value={this.state.N_pass}
                         onChange={(event) => {
                           this.setState({N_pass: event.target.value})
                         }}
                         InputProps={{
                           endAdornment: (
                             <InputAdornment position="end">
                               <IconButton aria-label="Toggle password visibility"
                                           onClick={() => {
                                             this.setState(state => ({N_passShow: !this.state.N_passShow}));
                                           }}>
                                 {this.state.N_passShow ? <VisibilityOff/> : <Visibility/>}
                               </IconButton>
                             </InputAdornment>
                           )
                         }}
                         variant="outlined"
                         style={{marginBottom: 16}}/>
              <TextField color="secondary"
                         id="password"
                         type={this.state.NC_passShow ? "text" : "password"}
                         label="确认密码"
                         fullWidth
                         value={this.state.NC_pass}
                         onChange={(event) => {
                           this.setState({NC_pass: event.target.value})
                         }}
                         InputProps={{
                           endAdornment: (
                             <InputAdornment position="end">
                               <IconButton aria-label="Toggle password visibility"
                                           onClick={() => {
                                             this.setState(state => ({NC_passShow: !this.state.NC_passShow}));
                                           }}>
                                 {this.state.NC_passShow ? <VisibilityOff/> : <Visibility/>}
                               </IconButton>
                             </InputAdornment>
                           )
                         }}
                         variant="outlined"
                         style={{marginBottom: 16}}/>
              <div className="week-submit-contain">
                <div className="week-submit" onClick={() => this.submit()}>确定</div>
              </div>
            </form>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

export default RoomDetailForm;
